
import Layout from 'components/Layout'
import Vue from 'vue'
import cookie from 'vux/src/tools/cookie/index.js'

import $ from 'jquery'
import 'admin-lte/bootstrap/css/bootstrap.min.css'
import 'admin-lte/plugins/datatables/dataTables.bootstrap.css'
import 'font-awesome/css/font-awesome.min.css'
import 'admin-lte/dist/css/AdminLTE.min.css'
import 'admin-lte/plugins/iCheck/square/_all.css'
import 'admin-lte/dist/css/skins/skin-yellow.min.css'
import 'admin-lte/dist/css/skins/skin-blue.min.css'

import 'admin-lte/bootstrap/js/bootstrap.min.js'
import 'admin-lte/plugins/iCheck/icheck.min.js'
import 'admin-lte/dist/js/app.min.js'
import 'admin-lte/plugins/slimScroll/jquery.slimscroll.min.js'
import 'admin-lte/plugins/morris/morris.min.js'

export default {
name: 'app',
components: {
Layout
},
created () {
if (cookie.get('XSRF-TOKEN') === undefined) {
window.location = '/xsrf';
}
},
mounted () {
}
}



// WEBPACK FOOTER //
// ./src/App.vue